var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { SdsContextMenuItem } from './sds-cm-item.lit';
import { SdsCheckbox } from '../../checkbox/sds-checkbox.lit';
import { SdsToggle } from '../../toggle/sds-toggle.lit';
import { applySearchAndReturnSortInfo, } from '../../shared/context-menu/item-search-sort';
import { sdsCustomElement } from '../../utilities/custom-components';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
/**
 * `sds-cm-select-item` is a context menu item component that represents
 * a selectable option within a context menu. It can display text,
 * manage selection state, and optionally show an icon.
 *
 * ## Usage
 * This component is intended to be used inside a context menu to represent
 * an interactive option the user can click or select.
 *
 * @tag sds-cm-select-item
 *
 * @attr {boolean} selected - Indicates if the item is currently selected.
 * @attr {boolean} disabled - Prevents user interaction with the item.
 * @attr {string} with-icon - True if the item has an icon.
 */
let SdsContextMenuSelectItem = (() => {
    var _SdsContextMenuSelectItem_selector_accessor_storage, _SdsContextMenuSelectItem_groupName_accessor_storage, _SdsContextMenuSelectItem_withSelectAll_accessor_storage, _SdsContextMenuSelectItem_indeterminate_accessor_storage, _SdsContextMenuSelectItem__highlightedName_accessor_storage, _SdsContextMenuSelectItem__highlightedSubname_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-cm-select-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsContextMenuItem;
    let _instanceExtraInitializers = [];
    let _set_selected_decorators;
    let _selector_decorators;
    let _selector_initializers = [];
    let _selector_extraInitializers = [];
    let _groupName_decorators;
    let _groupName_initializers = [];
    let _groupName_extraInitializers = [];
    let _withSelectAll_decorators;
    let _withSelectAll_initializers = [];
    let _withSelectAll_extraInitializers = [];
    let _indeterminate_decorators;
    let _indeterminate_initializers = [];
    let _indeterminate_extraInitializers = [];
    let __highlightedName_decorators;
    let __highlightedName_initializers = [];
    let __highlightedName_extraInitializers = [];
    let __highlightedSubname_decorators;
    let __highlightedSubname_initializers = [];
    let __highlightedSubname_extraInitializers = [];
    var SdsContextMenuSelectItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            /**
             * Controls whether the menu item is selected.
             *
             * @attr {boolean} selected - Indicates if the item is selected.
             * @default false
             */
            this._selected = (__runInitializers(this, _instanceExtraInitializers), false);
            _SdsContextMenuSelectItem_selector_accessor_storage.set(this, __runInitializers(this, _selector_initializers, void 0));
            _SdsContextMenuSelectItem_groupName_accessor_storage.set(this, (__runInitializers(this, _selector_extraInitializers), __runInitializers(this, _groupName_initializers, void 0)));
            _SdsContextMenuSelectItem_withSelectAll_accessor_storage.set(this, (__runInitializers(this, _groupName_extraInitializers), __runInitializers(this, _withSelectAll_initializers, false)));
            _SdsContextMenuSelectItem_indeterminate_accessor_storage.set(this, (__runInitializers(this, _withSelectAll_extraInitializers), __runInitializers(this, _indeterminate_initializers, false)));
            _SdsContextMenuSelectItem__highlightedName_accessor_storage.set(this, (__runInitializers(this, _indeterminate_extraInitializers), __runInitializers(this, __highlightedName_initializers, void 0)));
            _SdsContextMenuSelectItem__highlightedSubname_accessor_storage.set(this, (__runInitializers(this, __highlightedName_extraInitializers), __runInitializers(this, __highlightedSubname_initializers, void 0)));
            this.handleClick = (__runInitializers(this, __highlightedSubname_extraInitializers), (event) => {
                if (!this.disabled && !this.isSelectorComponent(event.target)) {
                    event.stopPropagation();
                    this.handleSelectionChange(!this.selected);
                }
            });
            this.handleToggleChange = (event) => {
                this.handleSelectionChange(event.detail.checked);
            };
            this.handleCheckboxChange = (event) => {
                this.handleSelectionChange(event.detail.checked);
            };
        }
        get selected() {
            return this._selected;
        }
        set selected(value) {
            const oldValue = this._selected;
            this._selected = value;
            if (oldValue !== value) {
                this.dispatchPropertyChange('selected', value, oldValue);
            }
            this.requestUpdate('selected', oldValue);
        }
        /**
         * Internal method for select components to set selection without triggering events
         * This should only be called from within the select components
         */
        setSelectedSilently(value) {
            const oldValue = this._selected;
            this._selected = value;
            this.requestUpdate('selected', oldValue);
        }
        /**
         * Defines the selector of this item.
         *
         * @attr {ContextMenuItemSelector} selector - Possible options: toggle, checkbox.
         * @default undefined
         */
        get selector() { return __classPrivateFieldGet(this, _SdsContextMenuSelectItem_selector_accessor_storage, "f"); }
        set selector(value) { __classPrivateFieldSet(this, _SdsContextMenuSelectItem_selector_accessor_storage, value, "f"); }
        /**
         * Specifies the group this item belongs to, allowing grouping of related menu items.
         *
         * @attr {string} group-name - The name of the group this item belongs to.
         * @default undefined
         */
        get groupName() { return __classPrivateFieldGet(this, _SdsContextMenuSelectItem_groupName_accessor_storage, "f"); }
        set groupName(value) { __classPrivateFieldSet(this, _SdsContextMenuSelectItem_groupName_accessor_storage, value, "f"); }
        /**
         * Specifies if this item is a "select all" item.
         *
         * @attr {boolean} with-select-all - If true, the item provides a "select all" option for context menu.
         * @default false
         */
        get withSelectAll() { return __classPrivateFieldGet(this, _SdsContextMenuSelectItem_withSelectAll_accessor_storage, "f"); }
        set withSelectAll(value) { __classPrivateFieldSet(this, _SdsContextMenuSelectItem_withSelectAll_accessor_storage, value, "f"); }
        /**
         * Controls the indeterminate state of the menu item, typically used for "select all" behavior.
         * An indeterminate state indicates that some, but not all, items are selected.
         *
         * @attr {boolean} indeterminate - If true, the item is in an indeterminate state.
         * @default false
         */
        get indeterminate() { return __classPrivateFieldGet(this, _SdsContextMenuSelectItem_indeterminate_accessor_storage, "f"); }
        set indeterminate(value) { __classPrivateFieldSet(this, _SdsContextMenuSelectItem_indeterminate_accessor_storage, value, "f"); }
        get _highlightedName() { return __classPrivateFieldGet(this, _SdsContextMenuSelectItem__highlightedName_accessor_storage, "f"); }
        set _highlightedName(value) { __classPrivateFieldSet(this, _SdsContextMenuSelectItem__highlightedName_accessor_storage, value, "f"); }
        get _highlightedSubname() { return __classPrivateFieldGet(this, _SdsContextMenuSelectItem__highlightedSubname_accessor_storage, "f"); }
        set _highlightedSubname(value) { __classPrivateFieldSet(this, _SdsContextMenuSelectItem__highlightedSubname_accessor_storage, value, "f"); }
        updated(changedProperties) {
            var _a, _b;
            super.updated(changedProperties);
            // Set aria-selected based on selected state
            if (changedProperties.has('selected')) {
                this.setAttribute('aria-selected', this.selected ? 'true' : 'false');
            }
            // Set aria-label for accessibility when name, tooltip, or avatar changes
            if (changedProperties.has('name') ||
                changedProperties.has('tooltip') ||
                changedProperties.has('_avatar')) {
                let ariaLabel = this.name || this.tooltip || '';
                // For items with avatars, use the avatar's name if available
                if (this.withAvatar && ((_b = (_a = this._avatar) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name)) {
                    ariaLabel = this._avatar[0].name;
                }
                if (ariaLabel) {
                    this.setAttribute('aria-label', ariaLabel);
                }
                else {
                    this.removeAttribute('aria-label');
                }
            }
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-cm-select-item', this.stylesGlobal.cssText);
            return this.renderInWrapper(html `
                ${this.renderIcon()}
                <div class="sds-cm-item__content">
                    ${this.renderAvatar()} ${this.renderName()} ${this.renderDescription()}
                </div>
                ${this.renderSelectedIcon()} ${this.renderSelector()}
            `);
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        // region search item implementation
        getPrimaryField() {
            return this.name;
        }
        getSecondaryField() {
            return this.description || this.subname;
        }
        setPrimaryFieldHighlight(template) {
            this._highlightedName = template;
        }
        setSecondaryFieldHighlight(template) {
            this._highlightedSubname = template;
        }
        getHighlightClass() {
            return 'sds-cm-item__highlighted-text';
        }
        applySearchAndReturnSortInfo(searchFilter) {
            var _a;
            if (this.withAvatar && ((_a = this._avatar) === null || _a === void 0 ? void 0 : _a[0])) {
                return this._avatar[0].applySearchAndReturnSortInfo(searchFilter);
            }
            return applySearchAndReturnSortInfo(this, searchFilter);
        }
        // endregion
        renderInWrapper(content) {
            return html `
            <div class="${this.getClasses()}" @click="${this.handleClick}">${content}</div>
        `;
        }
        renderName() {
            if (this._highlightedName) {
                return html `
                <div class="sds-cm-item__title">
                    <sds-clipped-text basic text="${this.name}"
                        ><span slot="container">${this._highlightedName}</span></sds-clipped-text
                    >
                </div>
            `;
            }
            return super.renderName();
        }
        renderDescription() {
            if (this._highlightedSubname) {
                return html ` <div class="sds-cm-item__description">${this._highlightedSubname}</div> `;
            }
            return super.renderDescription();
        }
        renderSelectedIcon() {
            if (!this.selector && this.selected) {
                return html `
                <sds-icon
                    class="sds-cm-item__action sds-cm-item__action--checked"
                    size="16"
                    name="check"
                ></sds-icon>
            `;
            }
        }
        renderSelector() {
            switch (this.selector) {
                case 'toggle':
                    return this.renderToggle();
                case 'checkbox':
                    return this.renderCheckbox();
            }
        }
        renderToggle() {
            return html `
            <sds-toggle
                class="sds-cm-item__action"
                size="sm"
                ?checked="${this.selected}"
                ?disabled="${this.disabled}"
                @sds.toggle.changed="${this.handleToggleChange}"
            ></sds-toggle>
        `;
        }
        renderCheckbox() {
            return html `
            <sds-checkbox
                class="sds-cm-item__action"
                ?checked="${this.selected}"
                ?disabled="${this.disabled}"
                ?indeterminate="${this.indeterminate}"
                @sds.checkbox.changed="${this.handleCheckboxChange}"
            ></sds-checkbox>
        `;
        }
        handleSelectionChange(selected) {
            this.setSelectedSilently(selected);
            const event = new CustomEvent(SdsContextMenuSelectItem.CM_ITEM_SELECTION_CHANGE, {
                detail: {
                    identifier: this.identifier,
                    selected: this.selected,
                },
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(event);
        }
        isSelectorComponent(element) {
            return element instanceof SdsToggle || element instanceof SdsCheckbox;
        }
        getClasses() {
            return classMap({
                'sds-cm-item': true,
                'sds-cm-item--heading': this.heading,
                'sds-cm-item--has-icon': this.withIcon,
                'sds-cm-item--disabled': this.disabled,
                'sds-cm-item--with-toggle': this.selector === 'toggle',
                'sds-cm-item--with-checkbox': this.selector === 'checkbox',
                'sds-cm-item--focused': this.focused,
                'sds-cm-item--selected': this.selected,
                'sds-cm-item--all': this.withSelectAll,
            });
        }
    };
    _SdsContextMenuSelectItem_selector_accessor_storage = new WeakMap();
    _SdsContextMenuSelectItem_groupName_accessor_storage = new WeakMap();
    _SdsContextMenuSelectItem_withSelectAll_accessor_storage = new WeakMap();
    _SdsContextMenuSelectItem_indeterminate_accessor_storage = new WeakMap();
    _SdsContextMenuSelectItem__highlightedName_accessor_storage = new WeakMap();
    _SdsContextMenuSelectItem__highlightedSubname_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsContextMenuSelectItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _set_selected_decorators = [property({ type: Boolean, reflect: true })];
        _selector_decorators = [property()];
        _groupName_decorators = [property({ attribute: 'group-name' })];
        _withSelectAll_decorators = [property({ attribute: 'with-select-all', type: Boolean })];
        _indeterminate_decorators = [property({ type: Boolean })];
        __highlightedName_decorators = [state()];
        __highlightedSubname_decorators = [state()];
        __esDecorate(_classThis, null, _set_selected_decorators, { kind: "setter", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _selector_decorators, { kind: "accessor", name: "selector", static: false, private: false, access: { has: obj => "selector" in obj, get: obj => obj.selector, set: (obj, value) => { obj.selector = value; } }, metadata: _metadata }, _selector_initializers, _selector_extraInitializers);
        __esDecorate(_classThis, null, _groupName_decorators, { kind: "accessor", name: "groupName", static: false, private: false, access: { has: obj => "groupName" in obj, get: obj => obj.groupName, set: (obj, value) => { obj.groupName = value; } }, metadata: _metadata }, _groupName_initializers, _groupName_extraInitializers);
        __esDecorate(_classThis, null, _withSelectAll_decorators, { kind: "accessor", name: "withSelectAll", static: false, private: false, access: { has: obj => "withSelectAll" in obj, get: obj => obj.withSelectAll, set: (obj, value) => { obj.withSelectAll = value; } }, metadata: _metadata }, _withSelectAll_initializers, _withSelectAll_extraInitializers);
        __esDecorate(_classThis, null, _indeterminate_decorators, { kind: "accessor", name: "indeterminate", static: false, private: false, access: { has: obj => "indeterminate" in obj, get: obj => obj.indeterminate, set: (obj, value) => { obj.indeterminate = value; } }, metadata: _metadata }, _indeterminate_initializers, _indeterminate_extraInitializers);
        __esDecorate(_classThis, null, __highlightedName_decorators, { kind: "accessor", name: "_highlightedName", static: false, private: false, access: { has: obj => "_highlightedName" in obj, get: obj => obj._highlightedName, set: (obj, value) => { obj._highlightedName = value; } }, metadata: _metadata }, __highlightedName_initializers, __highlightedName_extraInitializers);
        __esDecorate(_classThis, null, __highlightedSubname_decorators, { kind: "accessor", name: "_highlightedSubname", static: false, private: false, access: { has: obj => "_highlightedSubname" in obj, get: obj => obj._highlightedSubname, set: (obj, value) => { obj._highlightedSubname = value; } }, metadata: _metadata }, __highlightedSubname_initializers, __highlightedSubname_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsContextMenuSelectItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CM_ITEM_SELECTION_CHANGE = 'sds.cm.item.selection.change';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsContextMenuSelectItem = _classThis;
})();
export { SdsContextMenuSelectItem };
